import React, { Component } from 'react';
import moment from 'moment-timezone';

export default class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elapsed: this.calculateElapsed(),
    };
  }
  componentDidMount() {
    this.timer = setInterval(this.tick, 1000);

    const elapsed = this.calculateElapsed();
    if (elapsed !== this.state.elapsed) {
      this.setState({ elapsed: elapsed });
    }
  }

  calculateElapsed() {
    if (!this.props.start || !this.props.timezone) {
      return null;
    }

    const nowLocaleString = new Date().toLocaleDateString('en-us', {
      timeZone: this.props.timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const startInFacilityTimezone = moment.utc(this.props.start);
    const nowInFacilityTimezone = moment.utc(nowLocaleString);

    const minutes = startInFacilityTimezone.diff(
      nowInFacilityTimezone,
      'minutes'
    );
    return minutes;
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  tick = () => {
    const elapsed = this.calculateElapsed();
    if (elapsed !== this.state.elapsed) {
      this.setState({ elapsed: this.calculateElapsed() });
    }
  };
  render() {
    const { elapsed } = this.state;
    const textColor = elapsed <= 0 ? 'red' : 'black';
    return (
      <div style={{ textAlign: 'center' }}>
        <span style={{ color: textColor, fontWeight: 'bold' }}>{elapsed}</span>
      </div>
    );
  }
}
